module.exports = __webpack_public_path__ + "img/22.2316d692.jpg";